export enum DefaultInternetCloudNodeDisplay {
  x1 = -56,
  y1 = 6.1,
}
